export const defaultPagination = {
  PER_PAGE: 25,
  OFFSET: 0,
};

export const searchType = {
  NEW_SEARCH: "NEW_SEARCH",
  NEXT_PAGE: "NEXT_PAGE",
};
